<div class="container-fluid">
  <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warningForChange" appendTo="body" [closable]="false"></p-confirmDialog>
  <div class="row" style="margin-top: 10px;" style="padding: 0px;">
    <div class="col-12 flex">
      <div class="p-0" [ngClass]="{'col-1':!showFilter, 'col-3':showFilter}">
        <div class="col-12 flex p-0">
          <div class="col-11 p-0" *ngIf="showFilter">
            <div class="col">
              <div class="row">
                <div class="col-10" id="multiselectDiv">
                  <div class="col-12">
                    <div class="ui-inputgroup" id="filterLabel">
                      <button pButton class="theme-button noHover labelButton" type="button" label="Filter "></button>
                      <p-multiSelect [options]="filterOptions" (onChange)="getRunIdStatusList()" [(ngModel)]="selectedStates"
                        id="multiselectStatuses" optionLabel="label" optionValue="value" [style]="{'width':'70%'}" >
                        <ng-template let-item pTemplate="selectedItem">
                          <span style="vertical-align:middle">{{item.label}}</span>
                        </ng-template>
                        <ng-template let-status pTemplate="item">
                          {{status.label}}
                        </ng-template>
                      </p-multiSelect>
                    </div>
                  </div>
                </div>
                <div class="col-2" id="refreshBatchesDiv">
                  <button pButton style="width: 74%;" class="refreshBatches" (click)="getRunIdStatusList()" icon="fa fa-refresh"></button>
                </div>
                <div class="row p-0" id="datePicker">
                  <div class="col-6 p-1">
                    <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="getRunIdStatusList()"
                      (onClearClick) = "getRunIdStatusList()" (onTodayClick) = "getRunIdStatusList()"
                       dateFormat="yy-mm-dd" [showIcon]="true"
                      placeholder="From" showButtonBar="true"  [maxDate]="toDate"></p-calendar>
                  </div>
                  <div class="col-6 p-1">
                    <p-calendar [(ngModel)]="toDate" [minDate]="fromDate" readonlyInput="true"
                      (onSelect)="getRunIdStatusList()" (onClearClick) = "getRunIdStatusList()" (onTodayClick) = "getRunIdStatusList()"
                      dateFormat="yy-mm-dd"
                      [showIcon]="true" placeholder="To" showButtonBar="true" ></p-calendar>
                  </div>
                </div>
                <div class="row col-12" style=" margin-left: 1%;">
                  <label class="m-0">Number Of Run Matching Filter: <label class="m-0 font-bold text-success"
                      style="font-size: 1.2rem;">{{runStatusList == null ? 0: runStatusList.length}}</label></label>
                </div>
                <p-table [value]="runStatusList" selectionMode="single" [scrollable]="true" scrollHeight="60vh"
                  (onRowSelect)="batchViewVisbility($event)" [loading]="loading">
                  <ng-template pTemplate="header">
                    <tr>
                      <th scope="col" style="width: 40%;" class="batch">Run ID</th>
                      <th scope="col" class="status">Status</th>
                    </tr>
                  </ng-template>
                  <ng-template  let-run  pTemplate="body" let-batch>
                    <tr [pSelectableRow]="run">
                      <td style="width: 40%;"
                        [class]="(batch?.rushSample == true) ? 'rushBody pr-0': 'normalBody pr-0'">
                        {{run?.runId}}
                        <span *ngIf="run?.gxp" class="text-danger font-bold">GxP</span>
                        </td>
                      <td [class]="(batch?.rushSample == true) ? 'rushBody pr-0': 'normalBody pr-0'">
                        {{run?.status}}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
          <div [class]="showFilter ? 'col-1 pr-0' : 'col-3 pr-0 float-right'">
            <p-toggleButton [(ngModel)]="showFilter" onLabel="" offLabel="" onIcon="fa fa-chevron-circle-left"
              offIcon="fa fa-chevron-circle-right" [style]="{'width':'100%','margin-top':'20rem'}"></p-toggleButton>
          </div>
        </div>
      </div>
      <div [class]="showFilter ? 'col-9' :'col-11'" style=" border-left: 1px solid #186BA0;">
        <div class="col-12 flex" id="topGroup">
          <div class="col-4 p-0">
            <div class="ui-inputgroup userIdLable" style="margin-top: 10px;">
              <button pButton class="theme-button noHover labelButton" type="button" label="User ID" style="width: 44%;"></button>
              <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" maxlength="4"
                style="width: 50%; border-radius: 1px; height: 30px;" placeholder="User ID" readonly />
            </div>
            <div class="ui-inputgroup userIdLable" style="margin-top: 10px;">
              <button pButton class="theme-button noHover labelButton" type="button" label="Run ID" style="width: 44%;"></button>
              <input pInputText name="SearchSample" [(ngModel)]="valueToSearch" size="17"
                (keydown.enter)="searchForRunWIthFilter()" style=" border-radius: 1px;width: 50%; height: 33px;" />
              <button pButton icon="fa fa-search" class="h-2rem" style="width: 6%;" [disabled]="searchButtonDisabledIf()"
                (click)="searchForRunWIthFilter()">
              </button>
            </div>
            <div class="col-12 w-75 p-0">
              <button pButton *ngIf="libraryActionAllowedStatuses.includes(selectedRun?.status)" icon="fa fa-download" label="Export Data For D&P" class="buttonsRound"
                (click)="exportDPData()" [disabled]="!selectedRun?.runId"></button>
              <a href="javascript:void(0)" class="linkFont" *ngIf="selectedRun?.dpDataExportFileName" (click)="downloadDnPFile(selectedRun?.dpDataExportFileName, null)">{{selectedRun?.dpDataExportFileName}}</a>
            </div>
            <div class="col-12 p-0 legendContainer" *ngIf="showPlateView">
              <div class="col-12 flex p-0">
                <div class="col-6 flex legendInnerBorder">
                  <div class="col-3 p-0">
                    <div class="legendBox legendPhix">

                    </div>
                  </div>
                  <div class="col-9 p-0">
                    PhiX
                  </div>
                </div>
                <div class="col-6 flex legendInnerBorder">
                  <div class="col-3 p-0">
                    <div class="legendBox legendOverdue">

                    </div>
                  </div>
                  <div class="col-9 p-0">
                    Overdue
                  </div>
                </div>
              </div>
              <div class="col-12 flex p-0">
              <div class="col-6 flex legendInnerBorder">
                <div class="col-3 p-0">
                  <div class="legendBox legendDueless">

                  </div>
                </div>
                <div class="col-9 p-0">
                  Due in &#60;=5
                </div>
              </div>
              <div class="col-6 flex legendInnerBorder">
                <div class="col-3 p-0">
                  <div class="legendBox legendDuemore">

                  </div>
                </div>
                <div class="col-9 p-0">
                  Due in &#62;5
                </div>
              </div>
              </div>
            </div>
          </div>
          <div class="col-5 topDivspacing" style="text-align:left;">
            <div class="col-12 flex headers topDivspacing" style="height: 32px;" id="topDiv">
              <div class="col-5">
                <h5 style="color:#1F89CE; font-size: 19px; width: 200px;">
                  Run</h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;" class="col-1 pr-0 pl-0">
                <h5>
                  :
                </h5>
              </div>
              <div class="col-6">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedRun?.runId}}</strong>
                  <span *ngIf="selectedRun?.gxp" class="text-danger font-bold">GxP</span>
                </h5>
              </div>
            </div>
            <div class="col-12 flex headers" style="height: 32px;">
              <div class="col-5">
                <h5 style="color:#1F89CE; font-size: 19px; width: 200px;">
                  Sequencer Type
                </h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;" class="col-1 pr-0 pl-0">
                <h5>
                  :
                </h5>
              </div>
              <div class="col-6">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedRun?.sequencerType}} </strong>
                </h5>
              </div>
            </div>
            <div class="col-12 flex headers" style="height: 32px;">
              <div class="col-5">
                <h5 style="color:#1F89CE; font-size: 19px; width: 200px;">
                  Flowcell
                </h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;" class="col-1 pr-0 pl-0">
                <h5>
                  :
                </h5>
              </div>
              <div class="col-6">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedRun?.flowCellName}} </strong>
                </h5>
              </div>
            </div>
            <div class="col-12 flex headers" style="height: 32px;" *ngIf="checkForONTRun()">
              <div class="col-5">
                <h5 style="color:#1F89CE; font-size: 19px; width: 200px;">
                  Flowcell ID
                </h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;" class="col-1 pr-0 pl-0">
                <h5>
                  :
                </h5>
              </div>
              <div class="col-6">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedRun?.flowCellId}} </strong>
                </h5>
              </div>
            </div>
            <div class="col-12 flex headers" style="height: 32px;">
              <div class="col-5">
                <h5 style="color:#1F89CE; font-size: 19px; width: 200px;">
                  Read Mode </h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;" class="col-1 pr-0 pl-0">
                <h5>
                  :
                </h5>
              </div>
              <div class="col-6">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedRun?.largestReadMode}} </strong>
                </h5>
              </div>
            </div>
            <div class="col-12 flex headers" style="height: 32px;">
              <div class="col-5">
                <h5 style="color:#1F89CE; font-size: 19px; width: 200px;">
                  Machine </h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;" class="col-1 pr-0 pl-0">
                <h5>
                  :
                </h5>
              </div>
              <div class="col-6">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedRun?.sequencerIntrument}}</strong>
                </h5>
              </div>
            </div>
            <div class="col-12 flex headers" style="height: 32px;">
              <div class="col-5">
                <h5 style="color:#1F89CE; font-size: 19px; width: 200px; word-wrap:break-word">
                  Start Date (Planned) </h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;" class="col-1 pr-0 pl-0">
                <h5>
                  :
                </h5>
              </div>
              <div class="col-6">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedRun?.planDate | date: dateTimeFormat}}</strong>
                </h5>
              </div>
            </div>
            <div class="col-12 flex headers" style="height: 32px;">
              <div class="col-5">
                <h5 style="color:#1F89CE; font-size: 19px; width: 200px;">
                  Status </h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;" class="col-1 pr-0 pl-0">
                <h5>
                  :
                </h5>
              </div>
              <div class="col-6">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedRun?.status}} </strong>
                </h5>
              </div>
            </div>
          </div>

          <div class="col-3 topDivspacing pl-0">
            <div class="col-12 p-0" >
              <button pButton [icon]="getViewPlateIcon(showPlateView)" [label]="getPlateViewButtonLabel(showPlateView)"
              [ngStyle]="buttonsRound" id="plateView" (click)="togglePlateView()"
                [disabled]="!selectedRun?.runId"></button>
            </div>
            <div class="col-12 flex" *ngIf="showPlateView && actionSelectionAllowed()">
              <div class="col-8 p-0">
                <p-dropdown name="runAction" [style]="{'width':'100%','border-radius':'5px 0px 0px 5px'}" [options]="actionOptions" [(ngModel)]="runActionSelection" placeholder="Select Action"></p-dropdown>
              </div>
              <div class="col-4 p-0">
                <button pButton class="goButton buttonHeight" type="button" label="Go" [disabled]="!runActionSelection" (click)="actionHandler()"></button>
              </div>
            </div>
            <div *ngIf="showPlateView" class="col-12 processingTableBody p-0" style="width: 97%">
              <div class="border-bottom headerDiv text-center">Comments</div>
              <div class="col-12" style="height: 100%; ">
                <div class="col-6 p-0 text-left">
                  <label class="font-bold commentBatchId"></label>
                </div>
                <div class="col-6 p-0 text-right">
                  <label class="commentPUIDDate">{{previewComment?.puid}} | {{previewComment?.commentDate |
                    date: dateTimeFormat}}</label>
                </div>
                <textarea [(ngModel)]="previewComment.userComment" type="text" name="comment"
                  placeholder="No comments entered" rows="5" id="commentArea" readonly></textarea>
                <div class="col-12 p-0 text-center" style="margin-top: 2%;">
                  <button  pButton class="font-bold h-2rem" style="width: 50%;"
                  [disabled]="isCommentViewDisabled()" label="View / Add"
                  (click)="showComments()">
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 p-0 pt-1" *ngIf="showPlateView && (selectedRun.status == 'DP_STARTED')">
              <div class="ui-inputgroup">
                <p-dropdown autoWidth="false" [style]="{'width':'34.4vh'}" [options]="printerList" [(ngModel)]="selectedPrinter" placeholder="Select Printer"></p-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" id="tableDiv" [hidden]="showPlateView">
          <fieldset [disabled]="false">
            <legend></legend>
            <div class="col-12" id="tableDiv">
              <table aria-describedby="Processing table" id="processingTable"
                style="border: 1px solid black; width: 100%; height: 100%; table-layout: fixed;">
                <thead id="processingTableHeader">
                  <tr>
                    <th scope="col">Sequencing</th>
                    <th scope="col">Seq Data Processing</th>
                    <th scope="col">Seq Run Review</th>
                  </tr>
                </thead>
                <tbody class="processingTableBody">
                  <tr>
                    <td class="processingTableBody">

                      <div class="col-12 parent">
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton label="Sequencing Run Planned" class="buttonsRound startButton"
                              [disabled]="true">
                            </button>
                          </div>
                          <div class="col-4 sibling">
                            {{selectedRun?.creationDate | date: dateTimeFormat}} <br />
                            {{selectedRun?.runPlannedPuid}}
                          </div>
                        </div>
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton label="Start Dilution & Pooling" class="buttonsRound startButton" (click)="saveRunStatus('DP_STARTED')"
                              [disabled]="disableDilutionAndPoolingStarted()">
                            </button>
                          </div>
                          <div class="col-4 sibling">
                            {{selectedRun?.dilutionAndPoolingStartedDateTime | date: dateTimeFormat}} <br />
                            {{selectedRun?.dilutionAndPoolingStartedPUID}}
                          </div>
                        </div>
                        <div class="col-12 flex parent">

                          <div class="col-8 child">
                            <button pButton label="Complete Dilution & Pooling" class="buttonsRound startButton" (click)="saveRunStatus('DP_COMPLETED')"
                              [disabled]="true">
                            </button>
                          </div>
                          <div class="col-4 sibling">
                            {{selectedRun?.dilutionAndPoolingCompletedDateTime | date: dateTimeFormat}} <br />
                            {{selectedRun?.dilutionAndPoolingCompletedPUID}}
                          </div>
                        </div>
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <p-overlayPanel #prepareDataOverlay [styleClass]="'confirm-overlay-container'">
                              <ng-template pTemplate="content">
                                <div class="flex flex-column align-items-center w-full gap-3 p-3 ">
                                  <p>{{getFlowcellIDInputMessage()}}</p>
                                  <input pInputText id="flowcell-id-input" aria-describedby="flowcellid-help-text" [(ngModel)]="scannedFlowCellID" placeholder="Enter Flowcell ID" (input)="scannedFlowCellID=scannedFlowCellID.trim()" required/>
                                  <small *ngIf="selectedRun.flowCellId" id="flowcellid-help-text">
                                    If required, you can also change the FlowCell ID in the text box above.
                                  </small>
                                  <div class="flex align-items-center gap-2 mt-3">
                                    <button pButton [label]="getPrepareDataOverlayAcceptButtonLabel()" (click)="saveFlowCellIDWithRun()" size="small" [disabled]="!scannedFlowCellID"></button>
                                    <button pButton [label]="getPrepareDataOverlayRejectButtonLabel()" class="p-button-outlined" (click)="prepareDataOverlay.hide()" size="small"></button>
                                  </div>

                                </div>
                              </ng-template>
                            </p-overlayPanel>
                            <button pButton label="Prepare Data For Analysis"
                              (click)="checkSequencerTypeForPrepareData($event)"
                              [disabled]="disablePrepareDataForAnalysis()" class="buttonsRound endButton"></button>
                          </div>

                          <div class="col-4 sibling">
                            {{selectedRun?.prepareDataForAnalysisDate | date: dateTimeFormat}} <br />
                            {{selectedRun?.prepareDataForAnalysisPUID}}
                          </div>
                        </div>
                        <div class="col-12" *ngIf="selectedRun?.prepareDataForAnalysisDate">
                          <span>Disassembling:</span> <span> {{selectedRun?.disassembling ? 'Done' : 'Failed'}}
                          </span><br />
                        </div>
                        <div class="col-12" *ngIf="selectedRun?.prepareDataForAnalysisDate && !checkForONTRun()">
                          <label>Run Config: </label> <a *ngIf="selectedRun?.runConfigURL" href="javascript:void(0);"
                            (click)="downloadSheet(selectedRun?.runConfigURL, 'runProcess_excel_download')"><u>{{selectedRun?.runConfigURL}}</u></a>
                          <label *ngIf="!selectedRun?.runConfigURL">Failed</label>
                        </div>
                        <div class="col-12" *ngIf="selectedRun?.prepareDataForAnalysisDate && !checkForONTRun()">
                          <label>Samplesheet: </label> <a *ngIf="selectedRun?.sampleSheetURL" href="javascript:void(0);"
                            (click)="downloadSheet(selectedRun?.sampleSheetURL, 'runProcess_excel_download')"><u>{{selectedRun?.sampleSheetURL}}</u></a>

                          <label *ngIf="!selectedRun?.sampleSheetURL">Failed</label>

                        </div>

                        <div class="col-12" *ngIf="selectedRun?.prepareDataForAnalysisDate && !checkForONTRun()">
                          <label>SamplesheetV2: </label> <a *ngIf="selectedRun?.sampleSheetURLV2" href="javascript:void(0);"
                            (click)="downloadSheet(selectedRun?.sampleSheetURLV2, 'runProcess_excel_download')"><u>{{selectedRun?.sampleSheetURLV2}}</u></a>

                          <label *ngIf="!selectedRun?.sampleSheetURLV2">Failed</label>

                        </div>
                        <div class="col-12" *ngIf="selectedRun?.prepareDataForAnalysisDate">
                          <label>Meta Data: </label> <a *ngIf="selectedRun?.metaDataFileURL" href="javascript:void(0);"
                            (click)="downloadSheet(selectedRun?.metaDataFileURL, 'runProcess_excel_download')"><u>{{selectedRun?.metaDataFileURL}}</u></a>

                          <span *ngIf="!selectedRun?.disassembling">Failed</span>

                        </div>
                        <div class="col-12" *ngIf="selectedRun?.prepareDataForAnalysisDate && checkForONTRun()">
                          <span>ONT Analysis Sheet: </span> <a *ngIf="selectedRun?.analysisSheetFileURL" href="javascript:void(0);"
                                                        (click)="downloadSheet(selectedRun?.analysisSheetFileURL, 'runProcess_excel_download')"><u>{{selectedRun?.analysisSheetFileURL}}</u></a>

                          <span *ngIf="!selectedRun?.disassembling">Failed</span>

                        </div>
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton label="Sequencing Run Started" class="buttonsRound startButton"
                              [disabled]="seqRunFlag " (click)="saveRunStatus('SEQ_RUN_STARTED')">
                            </button>
                          </div>
                          <div class="col-4 sibling">
                            {{selectedRun?.sequencingRunStartedDate | date: dateTimeFormat}} <br />
                            {{selectedRun?.sequencingRunStartedPUID}}
                          </div>
                        </div>
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton label="Sequencing Run Completed" class="buttonsRound thirdButton"
                              [disabled]="selectedRun?.status != 'SEQ_RUN_STARTED' && selectedRun?.status != 'READY_FOR_RUNQC'"
                              (click)="showRunCompletionSidebar()">
                            </button>
                          </div>
                          <div class="col-4 sibling">
                            {{selectedRun?.sequencingRunFinishedDateTime | date: dateTimeFormat}} <br />
                            {{selectedRun?.sequencingRunFinishedPUID}}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="processingTableBody">
                      <div class="col-12 parent">

                        <div class="col-12 flex parent">

                          <div class="col-8 child">
                            <button pButton label="Primary Analysis Started" class="buttonsRound startButton"
                              [disabled]="selectedRun?.status != 'SEQ_RUN_FINISHED' || checkForONTRun()"
                              (click)="saveRunStatus('PA_STARTED')">
                            </button>
                          </div>
                          <div class="col-4 sibling">
                            {{selectedRun?.primaryAnalysisStartedDateTime | date: dateTimeFormat}} <br />
                            {{selectedRun?.primaryAnalysisStartedPUID}}
                          </div>
                        </div>
                        <div class="col-12 flex parent">
                          <div class="col-8 child">
                            <button pButton label="Primary Analysis Completed"
                              [disabled]="selectedRun?.status != 'PA_STARTED' || selectedRun?.autoQCReportReceived" (click)="saveRunStatus('PA_FINISHED')"
                              class="buttonsRound thirdButton"></button>
                          </div>
                          <div class="col-4 sibling">
                            {{selectedRun?.primaryAnalysisFinishedDateTime | date: dateTimeFormat}} <br />
                            {{selectedRun?.primaryAnalysisFinishedPUID}}
                          </div>
                        </div>
                        <div class="col-12" [innerHTML] ="laneAutoRunQCReportDetail">
                        </div>

                      </div>
                    </td>
                    <td class="processingTableBody">

                      <div class="col-12 flex parent">

                        <div class="col-8 child">
                          <button pButton label="Start Manual Run Review" class="buttonsRound startButton"
                            [disabled]="disableStartManualRunReview()"
                            (click)="saveRunStatus('MANUAL_RUNQC_STARTED')">
                          </button>
                        </div>
                        <div class="col-4 sibling">
                          {{selectedRun?.runReviewStartedDateTime | date: dateTimeFormat}} <br />
                          {{selectedRun?.runReviewStartedPUID}}
                        </div>
                      </div>
                      <div class="col-12 flex parent">
                        <div class="col-8 child">
                          <button pButton label="Complete Manual Run Review"
                            [disabled]="disableManualRunReview()" (click)="showRunConfirmation=true"
                            class="buttonsRound thirdButton"></button>
                        </div>
                        <div class="col-4 sibling">
                          {{selectedRun?.runReviewFinishedDateTime | date: dateTimeFormat}} <br />
                          {{selectedRun?.runReviewFinishedPUID}}
                        </div>
                      </div>
                      <div class="col-12" >
                        <div class="col-12" [innerHTML] ="laneManualRunQCCompletedDetail">
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="processingTableBody pt-0 pr-0">
                      <div class="border-bottom headerDiv text-center">Comments</div>
                      <div class="col-12" style="height: 100%; ">
                        <div class="col-6 p-0 text-left">
                          <label class="font-bold commentBatchId"></label>
                        </div>
                        <div class="col-6 p-0 text-right">
                          <label class="commentPUIDDate">{{previewComment?.puid}} | {{previewComment?.commentDate |
                            date: dateTimeFormat}}</label>
                        </div>
                        <textarea [(ngModel)]="previewComment.userComment" type="text" name="comment"
                          placeholder="No comments entered" rows="5" id="commentArea" readonly></textarea>
                        <button style="margin-top: 2%;" pButton class="font-bold commentButton"
                          [disabled]="isCommentViewDisabled()" label="View/Add Comments"
                          (click)="showComments()"></button>
                      </div>
                    </td>
                    <td class="processingTableBody disableTD">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </fieldset>
        </div>

        <div class="col-12 laneContainer" *ngIf="showPlateView">
          <p-table [value]="laneViewList" [columns]="scrollableColsforLanelist" dataKey="laneId"
             rowExpandMode="single"  expandableRows="true" (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowClose($event)">
            <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
              <tr [pSelectableRow]="rowData" [style]="getStyleForLane(rowData)" >
                <td class="laneTd">
                  <div class="col-12 flex p-0">
                    <div class="col-1 laneText">
                      <div class="col-4 text-center p-0" *ngIf="(currentBusyLane == rowData['laneId'])">
                        <p-progressSpinner [style]="{width: '2rem', height: '2rem'}" strokeWidth="3" fill="#FFFFFF" animationDuration=".5s"></p-progressSpinner>
                      </div>
                      <div class="col-4" *ngIf="(currentBusyLane != rowData['laneId'])">
                      </div>
                      <div class="col-9 text-left p-0">
                        <b>{{rowData['laneId']}}</b>
                        <div *ngIf="rowData['gxp']" class="text-danger font-bold">GxP</div>
                      </div>
                    </div>
                    <div class="col-5">
                      <div class="col-12 flex p-0 laneBlockContainer lane">
                        <div *ngFor="let laneValue of getLaneBlocks(rowData.laneId)"
                          class="laneBlock" [ngStyle]="getLaneBlockStyle(laneValue)">
                        </div>
                      </div>
                    </div>
                    <div class="col-1 text-center laneText">
                      {{rowData['constraintId']}}
                    </div>
                    <div class="col-1 text-center laneText" *ngIf="expanded">
                      {{getTotalLibsCount(rowData)}}
                    </div>
                    <div class="col-1 text-center laneText" *ngIf="!expanded">
                      {{getTotalLibsCount(rowData)}} ({{getSelectLibCountForLane(rowData['laneId'])}})
                    </div>
                    <div class="col-2 text-center laneText">
                      {{rowData['totalReadsCount']}}
                    </div>
                    <div class="col-1 text-center laneText">
                      {{rowData['phixPercentage']}} %
                    </div>
                    <div class="col-1 text-center laneText" [pRowToggler]="rowData">
                        <em [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></em>
                    </div>
                  </div>
                  <div class="col-12 flex" *ngIf="!showDilutionView()">
                    <div class="col-4">
                      <table role="none" class="mappedReadsTable">
                        <tr>
                          <td class="mappingLabels">Total Mapped Reads:</td>
                          <td class="text-right">{{rowData['readsForLane']}}</td>
                        </tr>
                        <tr>
                          <td class="mappingLabels">Total Undetermined Reads:</td>
                          <td class="text-right">{{rowData['unknownReads']}}</td>
                        </tr>
                        <tr style="border-top: 1px solid black;">
                          <td class="mappingLabels">Total Reads:</td>
                          <td class="text-right">{{rowData['totalReads']}}</td>
                        </tr>
                      </table>
                    </div>
                    <div class="col-1 text-center textMedium">
                      Q30 [%]: {{rowData['q30Rate']}}
                    </div>
                    <div class="col-2 text-center">
                      <button pButton class="goButton" type="button" label="Unknown Tags" icon="fa fa-download"
                        (click)="generateUnkownTagCSV(selectedRun.runId, rowData['laneId'])" [disabled]="isUnknownTagsButtonActive(rowData['unknownTags'])">
                      </button>
                    </div>
                    <div class="col-2 text-center">
                      <div class="col-12  flex ui-inputgroup p-0 pt-2 pb-2">
                        <div class="col-8 p-0">
                          <p-dropdown name="qcStatuses" [options] ="qcStatuses" [(ngModel)]="selectedQCStatus"  [style]="{'width':'100%'}" placeholder="Select RunQC Decision"></p-dropdown>
                        </div>
                        <div class="col-4 p-0 flex justify-content-start">
                          <button pButton [disabled]="disableSaveBtn(rowData)" (click)="updateQCStatus(rowData['laneId'])" style="padding: 10%;height: 2.2rem;"><i class="fa fa-save"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="col-3 text-center float-right">
                      <button pButton class="goButton" type="button" label="Complete RunQC and Publish"
                       (click)="validateAllLibStatusAndConfirm(rowData['laneId'])" [disabled]="disableCompleteRunQC(rowData['laneId'])">
                      </button>
                    </div>
                  </div>
                  <div class="col-12 flex" *ngIf="showDilutionView()">
                    <div class="col-1">
                      <div class="ui-inputgroup flex h-2rem">
                        <input class="finalConcStyle" pInputText name="finalConc" [(ngModel)]="rowData['userInputFinalConc']" placeholder="final concentration"
                          type="number" step="0.1" (keydown.enter)="saveFinalConcentration(rowData)" [readonly]="finalConcInputSaveDisabled(rowData)"/>
                          <button pButton [disabled]="finalConcSaveDisabled(rowData)" (click)="saveFinalConcentration(rowData)" style="padding: 10%;"><i class="fa fa-save"></i></button>
                      </div>
                    </div>
                    <div class="col-2 text-center" *ngIf="!showReprintButton(rowData)">
                      <button pButton class="goButton startDnP" type="button" label="Start D&P" (click)="startDnP(rowData)"
                        [disabled]="isStartDnPDisabled(rowData)">
                      </button>
                    </div>
                    <div class="col-2 text-center" *ngIf="showReprintButton(rowData)">
                      <button pButton class="goButton startDnP" type="button" label="Print Pool Label" (click)="printPoolLabel(rowData['laneId'])">
                      </button>
                    </div>
                    <div class="col-2">
                      <p-fileUpload #fileUploader [style]="getUploadStyle()"
                        (uploadHandler)="onLogUpload($event, fileUploader, rowData)" mode="basic" customUpload="true" accept=".log,.txt"
                        chooseLabel="Upload Log File" auto="true" [disabled]="disableUpload(rowData)"></p-fileUpload>
                    </div>
                    <div class="col-2">
                      <button pButton class="goButton hamiltonDownload" type="button" label="Hamilton Workfile" icon="fa fa-download"
                        (click)="downloadHamiltonWorkfile(rowData)" [disabled]="hamiltonFileDownloadDisabled(rowData)">
                      </button>
                    </div>
                    <div class="col-2">
                      <button pButton class="goButton completeDnp" type="button" label="Complete D&P" [disabled]="isCompleteDnPDisabled(rowData)"
                         (click)="completeDnP(rowData)">
                      </button>
                    </div>
                    <div class="col-1 text-center">
                      <img alt="an warning symbol" *ngIf="laneDPWaitingMap.get(rowData['laneId'])" src="/assets/warning.png"  style="width: 3.4vh">
                    </div>
                    <div class="col-2 p-0 text-center font-bold" style="max-height: 4rem; overflow-y: auto;">
                      <ng-container *ngFor="let file of rowData?.dnPfiles">
                        <div class="col-12 p-0">
                          <a href="javascript:void(0)" (click)="downloadDnPFile(file, rowData['laneId'])">{{file}}</a>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-rowData>
              <tr class="bg-white">
                <p-table class="selectionTable"
                  [style]="{width: '100%','border': '1px solid #0072bc'}"
                  [value]="libraryIdTabledata" dataKey="libraryId" [columns]="scrollableColsforLibData" (onRowSelect)="clearAllSelectionBoolean()"
                  [scrollable]="true" [loading]="loading" [(selection)]="librarySelectionList" [metaKeySelection]="true" (onRowUnselect)="clearAllSelectionBoolean()"
                  selectionMode="multiple" (sortFunction)="customSort($event)" [customSort]="true" sortField="libraryId" [sortOrder]="1">
                  <br /><br />
                  <ng-template pTemplate="caption">
                    <table style="border: none; width: 100%;" aria-describedby="table to format">
                      <thead>
                        <th class="text-left border-none">
                          <label>Total Libs : {{getTotalLibsCount(rowData)}}</label>
                        </th>
                        <th class="text-center border-none">
                          <label>Selected Libs : {{getSelectLibCount()}}</label>
                        </th>
                        <th class="border-none flex justify-content-end">
                          <em class="fa fa-search"></em>
                          <input type="text" pInputText size="40" placeholder="Global Filter" class="p-1"
                            (input)="globalfilterLibrayTable($event.target.value, rowData)" style="width:auto"  [(ngModel)]="laneLibFilterValue">
                        </th>
                      </thead>
                    </table>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th scope="col" style="width: 2.25em"></th>
                      <th scope="col" class="text-center" pSortableColumn="concentration">Final Conc. pM <p-sortIcon
                        field="concentration"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="libraryId">Library ID <p-sortIcon
                          field="libraryId"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="plateBarcode">Plate BC <p-sortIcon
                        field="plateBarcode"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="projectName">Project <p-sortIcon
                          field="projectName"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="sampleName">Sample <p-sortIcon
                          field="sampleName"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="libraryType">LibType <p-sortIcon
                        field="libraryType"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="comment">Comment <p-sortIcon
                        field="comment"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="missingReads">Planned Reads <p-sortIcon
                          field="missingReads"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="readDeviationRel">Relative Reads Deviation [%] <p-sortIcon
                        field="readDeviationRel"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="manualRunQCStatus">Qc Status <p-sortIcon
                        field="manualRunQCStatus"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="status">Status <p-sortIcon
                          field="status"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="tagInfo">Tag <p-sortIcon
                          field="tagInfo"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="dueDateRawData">Raw Data Due date
                        <p-sortIcon field="dueDateRawData"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" style="width: 3em">
                        <p-checkbox [(ngModel)]="librayAllSelectMap[expandedLane]" binary="true"
                        (onChange)="onAllLibSelection($event.checked)">
                        </p-checkbox>
                      </th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-library let-expanded="expanded" let-rowData="rowData" let-columns="columns" let-rowIndex="rowIndex">
                    <tr [pSelectableRow]="library" [pSelectableRowIndex]="rowIndex" [pSelectableRowDisabled]="disableContainerLibSelection(library)" [style]="getStyleForOuterTableRow(library)">
                      <td *ngIf="isLibraryContainer(library)" style="width: 2.25em" >
                        <div [pRowToggler]="library">
                          <em [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></em>
                        </div>
                      </td>
                      <td *ngIf="!isLibraryContainer(library)" style="width: 2.25em">
                      </td>
                      <ng-container *ngFor="let col of columns">
                        <td *ngIf="col.field != 'libraryId' && col.field != 'sampleName' && col.field != 'projectName' && col.field != 'missingReads' && col.field != 'dueDateRawData' && col.field != 'tagInfo' && col.field != 'comment'
                                  && col.field != 'readDeviationRel'" class="text-center text-xs" style="overflow-wrap: break-word;width: 9em">
                          {{getValueforLib(col.field, library)}}
                        </td>
                        <td *ngIf="col.field == 'projectName'" style="width: 9em" >
                          {{library[col.field]}}
                          <div *ngIf="library['gxp']" class="text-danger font-bold">GxP</div>
                        </td>
                        <td *ngIf="col.field == 'sampleName'" class="text-center text-xs" style="width: 9em">
                          {{library[col.field]}}
                          <em *ngIf="library?.cancellationRequested" class="font-bold text-primary">&nbsp;Cancelled</em>
                        </td>
                        <td *ngIf="col.field == 'libraryId'"  class=" p-0 text-center text-xs" style="width: 9em">
                          {{library[col.field]}}
                          <span >
                            <em *ngIf="library['badTdf'] || library['manualPooling']" class="fa fa-2x fa-exclamation-triangle text-center text-danger" aria-hidden="true"></em>
                         </span>
                        </td>
                        <td *ngIf="col.field == 'missingReads'" class="text-center text-xs" style="width: 9em">
                          {{abbreviateNumber(library[col.field])}}
                        </td>
                        <td *ngIf="col.field == 'comment'" class="text-center text-xs" style="width: 20em">
                          <div (click)="commentOverlay.toggle($event)"
                          style="max-height: 4rem; overflow: hidden; text-overflow: ellipsis;  white-space: normal;
                            display: -webkit-box !important; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" [innerHTML]="library['comment']">
                        </div>
                        <div *ngIf ="library['comment'] && library['comment'].length >0">
                          <a (click)="commentOverlay.toggle($event)"   style="text-decoration: underline; color: #006B96;" >Show More</a>
                        </div>
                          <p-overlayPanel [style]="{'width':'20rem'}" #commentOverlay appendTo="body" [dismissable]="true" [baseZIndex]="10000000">
                              <ng-template pTemplate>
                                  <div style="overflow-wrap: break-word;" [innerHTML]="library['comment']">
                                  </div>
                              </ng-template>
                          </p-overlayPanel>
                        </td>
                        <td class="relativeReads" *ngIf="col.field == 'readDeviationRel'" class="text-center text-xs" [pTooltip]="getLibReadsString(library)" tooltipStyleClass="readsTooltip" style="width: 12em">
                          {{getRelativeReads(library['libraryId'])}}
                        </td>
                        <td *ngIf="col.field == 'dueDateRawData'" class="text-center text-xs" style="width: 9em">
                          {{library[col.field] | date: dateFormat}}
                        </td>
                        <td *ngIf="col.field == 'tagInfo'" class="text-center text-xs" style="word-wrap: break-word;width: 9em">
                          {{library[col.field][0].tagManufacturerindex}}<br> {{library[col.field][0].tagSequence}}
                          <div *ngIf ="library['tagComment'] && library['tagComment'].length >0">
                            <a (click)="tagOverlay.toggle($event)"   style="text-decoration: underline; color: #006B96;" >Show Comment</a>
                            <p-overlayPanel [style]="{'width':'20rem'}" #tagOverlay appendTo="body" [dismissable]="true" [baseZIndex]="10000000">
                              <ng-template pTemplate>
                                  <div style="overflow-wrap: break-word;" [innerHTML]="library['tagComment']">
                                  </div>
                              </ng-template>
                          </p-overlayPanel>
                          </div>
                        </td>
                      </ng-container>
                      <td style="width: 3em">
                      </td>
                    </tr>
                  </ng-template>

                  <ng-template  pTemplate="rowexpansion" let-containerLib let-rowData ="rowData" let-columns="columns">
                    <tr  class="contained-row">
                      <td class="p-0" [attr.colspan]="columns.length + 2">
                        <p-table [value]="getContainerLibraries(containerLib['libraryId'])" (onRowUnselect)="clearAllSelectionBoolean()"
                        (onRowSelect)="clearAllSelectionBoolean()" [(selection)]="librarySelectionList"  selectionMode="multiple" [metaKeySelection]="true"
                        dataKey="libraryId">
                          <ng-template pTemplate="body" let-containedLib let-rowData="rowData" let-rowIndex="rowIndex"  >
                            <tr [pSelectableRow]="containedLib" [pSelectableRowIndex]="rowIndex" [pSelectableRowDisabled] ="disablePooledRowSelection()" >
                              <td style="width: 2.25em" class="text-center"> </td>
                              <ng-container *ngFor="let col of columns">
                                <td *ngIf="col.field != 'missingReads'&& col.field != 'projectName' && col.field != 'sampleName' && col.field != 'libraryId'  && col.field != 'dueDateRawData' && col.field != 'tagInfo' && col.field != 'comment'
                                  && col.field != 'readDeviationRel'" class="text-center text-xs" style="overflow-wrap: break-word;width: 9em">
                                  {{getValueforLib(col.field, containedLib)}}
                                </td>
                                <td *ngIf="col.field == 'projectName'" style="width: 9em">
                                  {{containedLib[col.field]}}
                                  <div *ngIf="containedLib['gxp']" class="text-danger font-bold">GxP</div>
                                </td>
                                <td *ngIf="col.field == 'sampleName'" class="text-center text-xs" style="width: 9em">
                                  {{containedLib[col.field]}}
                                  <em *ngIf="containedLib?.cancellationRequested" class="font-bold text-primary">&nbsp;Cancelled</em>
                                </td>
                                <td *ngIf="col.field == 'libraryId'"  class="text-center text-xs" style="width: 9em">
                                  {{containedLib[col.field]}}
                                  <span >
                                    <em *ngIf="containedLib['badTdf'] || containedLib['manualPooling']"   class="fa fa-2x fa-exclamation-triangle text-center text-danger" aria-hidden="true"></em>
                                 </span>
                                </td>
                                <td *ngIf="col.field == 'missingReads'" class="text-center text-xs" style="width: 9em">
                                  {{abbreviateNumber(containedLib[col.field])}}
                                </td>
                                <td *ngIf="col.field == 'comment'" class="text-center text-xs" style="width: 20em">
                                  <div (click)="commentOverlay.toggle($event)"
                                  style="max-height: 4rem; overflow: hidden; text-overflow: ellipsis;  white-space: normal;
                                    display: -webkit-box !important; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" [innerHTML]="containedLib['comment']">
                                </div>
                                <div *ngIf="containedLib['comment'] && containedLib['comment'].length >0">
                                  <a (click)="commentOverlay.toggle($event)"   style="text-decoration: underline; color: #006B96;" >Show More</a>
                                </div>
                                  <p-overlayPanel [style]="{'width':'20rem'}" #commentOverlay appendTo="body" [dismissable]="true" [baseZIndex]="10000000">
                                      <ng-template pTemplate>
                                          <div style="overflow-wrap: break-word;" [innerHTML]="containedLib['comment']">
                                          </div>
                                      </ng-template>
                                  </p-overlayPanel>
                                </td>
                                <td *ngIf="col.field == 'readDeviationRel'" class="text-center text-xs" [pTooltip]="getLibReadsString(containedLib)" style="width: 12em">
                                  {{getRelativeReads(containedLib['libraryId'])}}
                                </td>
                                <td *ngIf="col.field == 'dueDateRawData'" class="text-center text-xs" style="width: 9em">
                                  {{containedLib[col.field] | date: dateFormat}}
                                </td>
                                <td *ngIf="col.field == 'tagInfo'" class="text-center text-xs" style="width: 9em">
                                  {{containedLib[col.field][0].tagManufacturerindex}}<br> {{containedLib[col.field][0].tagSequence}}
                                </td>
                              </ng-container>
                              <td style="width: 3em">
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="7" class="text-center">
                        No records found
                      </td>
                    </tr>
                  </ng-template>
              </p-table>
            <br /><br />
          </tr>
          </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>


<p-dialog header="Comments" [(visible)]="showCommentDialog" [modal]="true" [dismissableMask]="true"
  (onHide)="clearComment()">
  <div class="border border-info" id="commentShowDiv">

    <div *ngFor="let comment of comments; let i = index">
      <div class="col-12  p-0 commentBubbleSection" style="height: 100%; ">

        <div class="col-12 commentPUIDDate">
          <label class="m-0">{{comment.puid}} | {{comment.commentDate | date: dateTimeFormat}}</label>
        </div>

        <div *ngIf="comment.status == 'success' && comment.details == 'request'"
          class="col-12 commentPUIDDate font-bold">
          Request of {{comment.template}} has been successfully completed.&nbsp;
          <a href="javascript:void(0);" id="{{ 'wave' + i }}"
            (click)="downloadTemplate($event, 'runProcess_excel_download')">{{comment.fileName}}</a>
          has been downloaded.
        </div>

        <div *ngIf="comment.status == 'failed' && comment.details == 'request'"
          class="col-12 commentPUIDDate font-bold">
          Request of {{comment.template}} has failed for the file&nbsp;
          <a href="javascript:void(0);" id="{{ 'wave' + i }}"
            (click)="downloadTemplate($event, 'runProcess_excel_download')">{{comment.fileName}}</a>
          . Error: {{comment.error}}

        </div>

        <div *ngIf="comment.status == 'success' && comment.details == 'validation'"
          class="col-12 commentPUIDDate font-bold">
          <a href="javascript:void(0);" id="{{ 'wave' + i }}"
            (click)="downloadTemplate($event, 'runProcess_excel_download')">{{comment.fileName}}</a>
          &nbsp;is valid and will be used for primary analysis.
        </div>

        <div *ngIf="comment.status == 'failed' && comment.details == 'validation'"
          class="col-12 commentPUIDDate font-bold">
          <a href="javascript:void(0);" id="{{ 'wave' + i }}"
            (click)="downloadTemplate($event, 'runProcess_excel_download')">{{comment.fileName}}</a>
          &nbsp;is not valid and could not be used for primary analysis. Error: {{comment.error}}
        </div>

        <div *ngIf="comment.status == 'AutoRunQCImported' && comment.details == 'validation'"
          class="col-12 commentPUIDDate font-bold">
          <a href="javascript:void(0);" id="{{ 'wave' + i }}"
            (click)="downloadTemplate($event, 'autorunQC_reportfile')">{{comment.fileName}}</a>
          &nbsp;is valid and will be used for RunQC value import.
        </div>

        <div *ngIf="comment.status == 'AutoRunQCCompleted' && comment.details == 'request'"
          class="col-12 commentPUIDDate font-bold">
          Request of autoRunQC report file has been successfully completed.&nbsp;
          <a href="javascript:void(0);" id="{{ 'wave' + i }}"
            (click)="downloadTemplate($event, 'autorunQC_reportfile')">{{comment.fileName}}</a>
          has been downloaded.
        </div>

        <div *ngIf="comment.status == 'AutoRunQCRequestFailed' && comment.details == 'request'"
          class="col-12 commentPUIDDate font-bold">
          Request of autoRunQC report file has failed for file&nbsp;
          <a href="javascript:void(0);" id="{{ 'wave' + i }}"
            (click)="downloadTemplate($event, 'autorunQC_reportfile')">{{comment.fileName}}</a>
            Error: {{comment.error}}
        </div>

        <div *ngIf="comment.details == 'DPLaneLogFile'"class="col-12 commentPUIDDate font-bold">
          DP logfile &nbsp;
          <a href="javascript:void(0);" id="{{ 'wave' + i }}"
            (click)="downloadDnPFile(comment.fileName, '')">{{comment.fileName}}</a>
            has been uploaded successfully for {{comment.status}}
        </div>

        <div *ngIf="comment.details == 'DPLaneWorkFile'"class="col-12 commentPUIDDate font-bold">
          DP workfile &nbsp;
          <a href="javascript:void(0);" id="{{ 'wave' + i }}"
            (click)="downloadDnPFile(comment.fileName, '')">{{comment.fileName}}</a>
            has been created successfully for Lane {{comment.status}}
        </div>

        <div *ngIf="comment.details == 'DPLaneLogFileError'"class="col-12 commentPUIDDate font-bold">
          DP logfile &nbsp;
          <a href="javascript:void(0);" id="{{ 'wave' + i }}"
            (click)="downloadDnPFile(comment.fileName, '')">{{comment.fileName}}</a>
            upload has failed for {{comment.status}} because it is invalid
        </div>

        <div *ngIf=" comment.details == 'redo'" class="col-12 commentPUIDDate font-bold">
          {{comment.userComment.substring(0, comment.userComment.lastIndexOf(" ") + 1)}}<a class="text-primary" style="text-decoration:underline" [routerLink]="'/runprocess/' + comment.userComment.substring(comment.userComment.lastIndexOf(' ') + 1, comment.userComment.length)">{{comment.userComment.substring(comment.userComment.lastIndexOf(" ") + 1, comment.userComment.length)}}</a>
        </div>

        <div *ngIf="!comment.status && !comment.details" class="col-12 pt-0 pb-0 commentPUIDDate font-bold">
          <p [innerText]="comment.userComment"></p>
        </div>

      </div>
    </div>
  </div>
  <div id="commentTextAreDiv">
    <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
      [(ngModel)]="this.newComment.userComment"></textarea>
  </div>
  <p-footer>
    <button pButton label="Add Comment" [disabled]="disableAddCommentButton()" (click)="saveComment()"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Confirmation" [(visible)]="commentPopup" [modal]="true" [dismissableMask]="true">
  <label class="font-bold">Select appropriate option to proceed: </label>

  <p-footer>
    <button pButton class="bg-success" label="QC OK -> Continue" (click)="saveRunStatus('COMPLETED')"></button>
    <button pButton class="bg-danger" label="QC Failed" (click)="runReviewFinished('REDO')"></button>

  </p-footer>
</p-dialog>

<p-sidebar [(visible)]="showRemoveLibsSideBar" position="right" [baseZIndex]="10000"
  [dismissible]="true" [modal]="true" [style]="{'width':'45em', 'word-wrap': 'break-word'}">
  <div class="col-12 text-left" style="width: 100%; color: white; background-color: #006B96;">
    <label class="font-bold" style="font-size: x-large; margin-bottom: 0;">
      Remove Libraries
    </label>
  </div>

  <div *ngIf="removalEmptyLibsMessage" class="col-12 text-center" style="font-size: large; color: red;">
    {{removalEmptyLibsMessage}}
  </div>

  <div *ngIf="!removalEmptyLibsMessage" class="col-12">
    <div class="col-12 p-0">
      <label *ngIf="!(libraryCount > 1)">The following library will be removed: </label>
      <label *ngIf="(libraryCount > 1)">The following {{libraryCount}} libraries will be removed: </label>
    </div>
    <div class="col-12" style="max-height: 35vh; overflow-y: auto; border: 1px solid #006B96;">
      <div class="col-3" *ngFor="let lib of removalLibraryObjects">
        <label class="font-bold">{{lib['libraryId']}} ({{lib['project']}})</label>
      </div>
    </div>
  </div>

  <div *ngIf="!removalEmptyLibsMessage" class="col-12">
      <div class="col-12 flex justify-content-between">
        <button pButton label="Reject" class="p-button-raised border-round"
          (click)="closeRemovalSideBar()"></button>
        <button pButton label="Submit" class="p-button-raised border-round"
          (click)="submitRemoval()"></button>
      </div>
  </div>

  <div *ngIf="!removalEmptyLibsMessage && removelErrorReutrnMessage" class="col-12 text-center">
    <label style="font-size: large; color: red;">{{removelErrorReutrnMessage}}</label>
  </div>
</p-sidebar>

<p-sidebar [visible]="processViewSidebar || showRunConfirmation" position="left" [showCloseIcon]="false" [autoZIndex]="true" [blockScroll]="true"
 [style]="{'width':'27em','top': '76px','padding-top': '32px','height':'91vh'}">
  <div>
    <label class="m-0">Please select one of the below options to proceed:</label>
    <div class="col-12">
      <p-radioButton name="sequencingOptionsGroup" class="mt-2 ml-2" value="complete" [label]="getContinueRadioButtonLabel()"
        [(ngModel)]="sequencingRunContinuationValue"></p-radioButton><br />
      <p-radioButton name="sequencingOptionsGroup" class="ml-2 mt-1" value="abort" [label]= getAbortLabel()
        [(ngModel)]="sequencingRunContinuationValue"></p-radioButton>
      <p-radioButton *ngIf="checkForONTRun() && selectedRun?.status === 'MANUAL_RUNQC_STARTED'" name="sequencingOptionsGroup" class="ml-2 mt-1" value="abort with no copy" label="Run QC Failed, create No Copy of this Run"
                     [(ngModel)]="sequencingRunContinuationValue"></p-radioButton>
    </div>
    <div>
      <div class="col-12 mt-2 flex justify-content-center">
        <button pButton label="Submit" class="p-button-raised float-right"
          (click)="submitRunDecisionOnSequencingCompleted()"></button>&nbsp;&nbsp;&nbsp;&nbsp;
          <button pButton label="Exit" class="p-button-outlined p-button-raised"
          (click)="closeSidebar()"></button>
      </div>

    </div>
  </div>
</p-sidebar>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>



<p-dialog header="Log file errors" [(visible)]="showLogFileUploadError" [modal]="true" [dismissableMask]="true">
  <div [innerHTML]="logFileErrorMessage">

  </div>
  <p-footer>
    <p-footer>
      <button pButton label="OK" (click)="closeLogFileUploadErrorDialog()"></button>
    </p-footer>
  </p-footer>
</p-dialog>

<p-dialog header="Manual Pooling Step" [(visible)]="manualPoolingPopUp" [style]="{width: '25vw'}" [baseZIndex]="10000" [modal]="true">
  <div class="col-12 errorText text-center">
    {{dnPErrors}}
  </div>

  <div class="col-12" *ngIf="libTdfMore?.length > 0">
    <div><b>Libraries with Total dilution factor &gt; 80,000:</b></div>
    <div>{{libTdfMore.join(', ')}}</div>
    <div>{{getLibraryPlatePosView(libTdfMore)}}</div>
  </div>

  <div class="col-12">
    <div><b>Please scan the Pool-ID and one Library Barcode:</b></div>
    <div class="ui-inputgroup mt-1">
      <button pButton class="theme-button noHover labelDnPButton" type="button" label="Pool"></button>
      <input class="inputDnP" pInputText [(ngModel)]="completionPoolId" id="poolIdDnP" placeholder="Scan Pool ID" (keydown.enter)="shiftFocusToLibraryDnP()" (input)="disableCompletion()"/>
    </div>
    <div class="ui-inputgroup mt-1">
      <button pButton class="theme-button noHover labelDnPButton" type="button" label="Library"></button>
      <input class="inputDnP" pInputText [(ngModel)]="completionLibraryBarcode" id="libraryIdDnP" placeholder="Scan Library Barocde" (keydown.enter)="validateLibrary()" (input)="resetInputsForLibrary()" (blur)="validateLibrary()"/>
    </div>
    <div class="ui-inputgroup mt-1">
      <button pButton class="theme-button noHover labelDnPButton" type="button" label="Plate Barcode"></button>
      <input class="inputDnP" pInputText [(ngModel)]="completionPlateBarcode" id="plateIdDnP" placeholder="Scan Plate Barocde" [disabled]="isPlateScanDisabled()" (keydown.enter)="validatePlateBarcode()" (input)="resetInputsForPlateBarcode()" (blur)="validatePlateBarcode()"/>
    </div>
    <div class="ui-inputgroup mt-1">
      <button pButton class="theme-button noHover labelDnPButton" type="button" label="Plate Position"></button>
      <input class="inputDnP" pInputText [(ngModel)]="completionPlatePosition" id="platePosDnP" placeholder="Scan Plate Position" [disabled]="isPlateScanDisabled()" (keydown.enter)="validatePlatePosition()" (input)="resetInputForPlatePosition()" (blur)="validatePlatePosition()"/>
    </div>
  </div>

  <div class="col-12">
    <div><b>Total Dilution Factor: </b><b>{{libraryTdf}}</b></div>
  </div>

  <div class="col-12">
    <div><b>To Do: </b></div>
    <div class="col-12 p-0">
      <div class="col-2">

      </div>
      <div class="col-8 dnpSuggestionDiv">
        <table class="text-center" [hidden]="!showEbDilutionTable">
          <tr>
            <th class="dnPColWidth"></th>
            <th class="dnPColWidth">EB Volume</th>
            <th class="dnPColWidth">DNA Volume</th>
          </tr>
          <tr>
            <td>Dilution 1:</td>
            <td>36</td>
            <td>4</td>
          </tr>
          <tr>
            <td>Dilution 2:</td>
            <td>36</td>
            <td>4</td>
          </tr>
          <tr>
            <td>Dilution 3:</td>
            <td style="color: blue;">{{thirdDilutionValue}}</td>
            <td>4</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="col-12 adviceBorder text-center mt-2">
      <b>{{adviceString}}</b>
    </div>
  </div>

  <p-footer>
    <button *ngIf="!showCompleteButton()" pButton class="dnpDialogBtn completeDnp" type="button" label="Next Library"
      (click)="updateCurrentAndInitializeNextLibrary()" [disabled]="disableDnPUpdate">
    </button>
    <button *ngIf="showCompleteButton()" pButton class="dnpDialogBtn completeDnp" type="button" label="Complete D&P"
      (click)="finalizeCompleteDnP()" [disabled]="disableDnPUpdate">
    </button>
  </p-footer>
</p-dialog>

<p-sidebar [(visible)]="showChangeConcentrationSidebar" position="right" [baseZIndex]="10000"
  [dismissible]="true" [modal]="true" [style]="{'width':'45em', 'word-wrap': 'break-word'}">
  <div class="col-12 text-left" style="width: 100%; color: white; background-color: #006B96;">
    <label class="font-bold" style="font-size: x-large; margin-bottom: 0;">
      Change Final Concentration
    </label>
  </div>

  <div class="col-12 text-center" style="font-size: large; color: red;">
    <label>Concentration will be changed for the following libraries:</label>
  </div>

  <div class="col-12">
    <div class="col-12" style="max-height: 35vh; overflow-y: auto; border: 1px solid #006B96;">
      <div class="col-3" *ngFor="let lib of barcodesToChangeConcentration">
        <label class="font-bold">{{lib}}</label>
      </div>
    </div>
  </div>

  <div class="col-12 p-0 mt-3">
    <div class="col-12 p-0 mb-3 ml-3">
        <p-inputNumber placeholder="Final Concentration" size="30" [(ngModel)]="userConcentration" mode="decimal" [showButtons]="true" [min]="0" [step]="0.1"></p-inputNumber>
    </div>
  </div>

  <div class="col-12">
    <button pButton label="Submit" class="shadow-sm float-right"
      (click)="changeConcentrationForSelectedLibs()" [disabled]="isConcentrationChangeDisabled()"></button>
  </div>
</p-sidebar>
